
import { ChatListScreenNavigationProps } from "./types"
import React from "react"
import ChatList from "./chat-list-screen"
import { PageRoot } from "~screens/page-root"


const ChatListScreen: React.FC<ChatListScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <ChatList />
    </PageRoot>
  )
}

export default ChatListScreen
